import { render } from "./SecondTierAgent.vue?vue&type=template&id=12ebc6e4&scoped=true"
import script from "./SecondTierAgent.vue?vue&type=script&lang=js"
export * from "./SecondTierAgent.vue?vue&type=script&lang=js"

import "./SecondTierAgent.vue?vue&type=style&index=0&id=12ebc6e4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ebc6e4"]])

export default __exports__